// loại icon hiển thị tại msCellInput
export default {
  More: 0,
  View: 1,
  Edit: 2,
};
